'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _jsxFileName = 'src/SureDesignSystem/Select/Select.js';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _SelectModule = require('./Select.module.css');

var _SelectModule2 = _interopRequireDefault(_SelectModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  className: _propTypes2.default.string,
  wrapperClassName: _propTypes2.default.string,
  labelClassName: _propTypes2.default.string,
  errorClassName: _propTypes2.default.string,
  label: _propTypes2.default.node.isRequired,
  showLabelAsterisk: _propTypes2.default.bool,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.string
  })),
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func,
  touched: _propTypes2.default.bool,
  error: _propTypes2.default.string
};
var defaultProps = {
  className: null,
  wrapperClassName: null,
  labelClassName: null,
  errorClassName: null,
  showLabelAsterisk: false,
  value: '',
  touched: false,
  error: null
};

var Select = function (_PureComponent) {
  _inherits(Select, _PureComponent);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
  }

  _createClass(Select, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          wrapperClassName = _props.wrapperClassName,
          labelClassName = _props.labelClassName,
          errorClassName = _props.errorClassName,
          label = _props.label,
          showLabelAsterisk = _props.showLabelAsterisk,
          options = _props.options,
          name = _props.name,
          value = _props.value,
          _onChange = _props.onChange,
          _onBlur = _props.onBlur,
          touched = _props.touched,
          error = _props.error,
          props = _objectWithoutProperties(_props, ['className', 'wrapperClassName', 'labelClassName', 'errorClassName', 'label', 'showLabelAsterisk', 'options', 'name', 'value', 'onChange', 'onBlur', 'touched', 'error']);

      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_SelectModule2.default.wrapper, wrapperClassName),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        },
        __self: this
      }, _react2.default.createElement('label', {
        className: (0, _classnames2.default)(_SelectModule2.default.label, labelClassName),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63
        },
        __self: this
      }, label, showLabelAsterisk && _react2.default.createElement('span', {
        className: _SelectModule2.default.labelAsterisk,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        },
        __self: this
      }, '*'), _react2.default.createElement(_reactSelect2.default, _extends({}, props, {
        name: name,
        options: options,
        onBlur: function onBlur() {
          return _onBlur({
            target: {
              name: name
            }
          });
        },
        value: options ? (0, _find2.default)(options, function (option) {
          return option.value === value;
        }) : '',
        onChange: function onChange(option) {
          return _onChange({
            target: {
              name: name,
              value: (0, _get2.default)(option, 'value', '')
            }
          });
        },
        className: (0, _classnames2.default)(_SelectModule2.default.select, className),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        },
        __self: this
      }))), touched && error && _react2.default.createElement('p', {
        className: (0, _classnames2.default)(_SelectModule2.default.error, errorClassName),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81
        },
        __self: this
      }, error));
    }
  }]);

  return Select;
}(_react.PureComponent);

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
exports.default = Select;